import { useEffect, useRef, useState } from 'react';
import DialogForm from './DialogForm';
import { subscribeForbidden } from '../../common/forbiddenNotifier';

// Janela em que 403s tardios (ex.: várias chamadas da mesma tela) não reabrem a modal após fechar.
const REOPEN_COOLDOWN_MS = 2000;

// Modal global única exibida quando qualquer requisição da API retorna 403.
export default function ForbiddenDialog() {
  const [open, setOpen] = useState(false);
  const openRef = useRef(false);
  const lastClosedAt = useRef(0);

  useEffect(() => {
    return subscribeForbidden(() => {
      if (openRef.current) return;
      if (Date.now() - lastClosedAt.current < REOPEN_COOLDOWN_MS) return;
      openRef.current = true;
      setOpen(true);
    });
  }, []);

  const handleClose = () => {
    openRef.current = false;
    lastClosedAt.current = Date.now();
    setOpen(false);
  };

  return (
    <DialogForm
      open={open}
      onClose={handleClose}
      onSubmit={() => {}}
      title="Sem permissão"
      iconType="warning"
      content="Você não tem permissão para acessar esta funcionalidade. Procure o administrador."
      hideConfirmButton
      cancelButtonText="Fechar"
    />
  );
}
